$(function() {
    const $applyButton = $('#apply-code');
    const $promoWrapper = $('#promo-entry-wrapper');
    const $promoField = $('#promo-code-field');
    const $promoFieldWrapper = $('#promo-code');
    const $promoErrorField = $('#promo-code-error');
    const $registerForm = $('#workshop-form');

    $applyButton.on('click', function() {
        $promoErrorField.text('');
        $.post(
            $promoFieldWrapper.data('check-url'),
            {
                'ccm_token': $promoFieldWrapper.data('token'),
                'code': $promoField.val()
            },
            function(data) {
                $promoWrapper.replaceWith(data);
                $registerForm.trigger('wccrc:promo-code-applied');
            }
        )
            .fail(function(data) {
                $promoErrorField.text(data.responseJSON.message);
            })
    });
});
